import React, { FC } from 'react';

const FoodoraPermissions: FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M134.212 163.536H65.9638C49.6278 163.536 36.3398 150.248 36.3398 133.912V65.664C36.3398 49.328 49.6278 36.04 65.9638 36.04H134.216C150.552 36.04 163.84 49.328 163.84 65.664V133.916C163.836 150.248 150.548 163.536 134.212 163.536Z"
        fill="#FAF9F6"
      />
      <path
        d="M169.912 135.24L148.624 90.76C147.584 88.584 145.384 87.2 142.972 87.2H121.4L117.933 87.2041L59.8238 87.2C57.4118 87.2 55.2158 88.584 54.1718 90.76L32.8876 135.24L31.5197 138.572C30.7997 142.292 33.6317 146.004 37.6797 146.004H165.116C169.164 146.004 171.992 142.292 171.276 138.572L169.912 135.24Z"
        fill="#FFFFE7"
      />
      <path
        d="M158.101 151.416H42.077C40.8438 149.737 39.7829 147.925 38.9209 146.004H161.258C160.395 147.925 159.334 149.737 158.101 151.416Z"
        fill="#042F2E"
      />
      <path
        d="M119.884 118.188C121.044 116.58 123.252 115.42 126.016 114.904L121.708 100.152H66.512L61.02 119.456H119.228C119.376 119.016 119.592 118.592 119.884 118.188Z"
        fill="#0A4342"
      />
      <path
        d="M119.48 122.792H60.072L56.52 135.276H131.96L129.764 127.756C124.936 127.528 120.84 125.564 119.48 122.792Z"
        fill="#0A4342"
      />
      <path
        d="M63.0441 100.152H49.7841C49.7561 100.152 49.7281 100.144 49.6961 100.144L40.4561 119.456H57.5521L63.0441 100.152Z"
        fill="#0A4342"
      />
      <path
        d="M56.6082 122.792H38.8602L32.8882 135.276H53.0562L56.6082 122.792Z"
        fill="#0A4342"
      />
      <path
        d="M138.58 146.04H165.116C169.164 146.04 171.992 142.328 171.276 138.608H136.408L138.58 146.04Z"
        fill="#0A4342"
      />
      <path
        d="M31.5197 138.608C30.7997 142.328 33.6317 146.04 37.6797 146.04H49.9957L52.1077 138.608H31.5197Z"
        fill="#0A4342"
      />
      <path
        d="M151.508 96.82L148.624 90.796C147.584 88.62 145.384 87.236 142.972 87.236H121.4L124.2 96.82H151.508Z"
        fill="#0A4342"
      />
      <path
        d="M55.7121 138.8L53.6001 146.232H135.248L133.076 138.8H55.7121Z"
        fill="#0A4342"
      />
      <path
        d="M120.732 96.82L117.932 87.236H70.184L67.46 96.82H120.732Z"
        fill="#0A4342"
      />
      <path
        d="M66.7201 87.2H59.8241C57.4121 87.2 55.2161 88.584 54.1721 90.76L51.2881 96.784H63.9921L66.7201 87.2Z"
        fill="#0A4342"
      />
      <path
        d="M140.196 124.188C138.92 125.96 136.364 127.188 133.2 127.612L135.44 135.276H169.912L163.94 122.792H140.896C140.744 123.276 140.512 123.748 140.196 124.188Z"
        fill="#0A4342"
      />
      <path
        d="M129.4 114.604C134.548 114.608 139.028 116.584 140.536 119.46H162.34L153.104 100.156H125.18L129.4 114.604Z"
        fill="#0A4342"
      />
      <path
        d="M129.364 117.624C129.128 117.624 128.892 117.628 128.652 117.64C125.112 117.788 123.036 118.98 122.332 119.956C121.944 120.492 122 120.908 122.076 121.168C122.604 123.02 126.58 124.944 131.42 124.736C134.96 124.588 137.036 123.396 137.74 122.42C138.128 121.884 138.072 121.468 137.996 121.208C137.496 119.448 133.884 117.624 129.364 117.624Z"
        fill="#0A4342"
      />
      <path
        d="M136.74 64.6679C136.74 43.0199 117.988 25.7519 95.8401 28.2199C79.3201 30.0639 65.8841 43.2159 63.7041 59.6919C62.0081 72.5119 66.9801 84.2119 75.5841 91.9399H75.5561L97.9481 115.856H97.9601C98.4601 116.464 99.2081 116.856 100.052 116.856C100.828 116.856 101.524 116.528 102.02 116.004H102.028L124.588 91.9359H124.524C132.008 85.2239 136.74 75.5079 136.74 64.6679Z"
        fill="#DF1067"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.06 53.2252C94.4669 53.2252 89.933 57.7591 89.933 63.352C89.933 68.9449 94.4669 73.4788 100.06 73.4788C105.653 73.4788 110.187 68.9448 110.187 63.352C110.187 57.7591 105.653 53.2252 100.06 53.2252ZM83.8506 63.352C83.8506 54.3999 91.1077 47.1428 100.06 47.1428C109.012 47.1428 116.269 54.3999 116.269 63.352C116.269 72.3041 109.012 79.5612 100.06 79.5612C91.1077 79.5612 83.8506 72.3041 83.8506 63.352Z"
        fill="white"
      />
    </svg>
  );
};

export default FoodoraPermissions;
